import lexemeListDefault from 'containers/global-dating-trends/lexemes/en';
import indexMap from 'containers/global-dating-trends/lexemes/index-map';

const lexemeKeyList = indexMap;

export function findKeyLexeme({ lexemeId }: { lexemeId: string }) {
  let lexemeKey = undefined;
  try {
    // @ts-ignore
    lexemeKey = lexemeKeyList && lexemeKeyList[lexemeId];
  } catch (error) {
    console.log(error);
  }

  if (process.env.NODE_ENV !== 'production') {
    if (lexemeKey === undefined) {
      console.log(`lexeme key ${lexemeId} not found`);
    }
  }

  return lexemeKey;
}

export function findLexeme(lexemeList: string[], lexemeId: string) {
  const lexemeKey = findKeyLexeme({ lexemeId });
  let mockLexeme;

  try {
    mockLexeme = lexemeList[lexemeKey];
  } catch (error) {
    console.log(error);
  }

  if (process.env.NODE_ENV !== 'production') {
    if (!mockLexeme) {
      console.log(`lexeme ${lexemeId} not found`);
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    // return list[lexemeId]
  }

  return mockLexeme;
}

export function findDefaultLexeme(lexemeId: string) {
  const lexemeKey = findKeyLexeme({ lexemeId });
  let mockLexeme;

  try {
    mockLexeme = lexemeListDefault.lexemes[lexemeKey];
  } catch (error) {
    console.log(error);
  }

  if (process.env.NODE_ENV !== 'production') {
    if (!mockLexeme) {
      console.log(`lexeme ${lexemeId} not found`);
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    // return list[lexemeId]
  }

  return mockLexeme;
}

export async function setMockLexemes(lang: string) {
  let loc;
  try {
    loc = await import(`../../containers/global-dating-trends/lexemes/${lang}.js`).then(
      (module) => module.default,
    );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    console.log(`reset to defalut lang`);
    loc = await import('../../containers/global-dating-trends/lexemes/en.js').then(
      (module) => module.default,
    );
  }
  return loc.lexemes;
}
